"use client";

import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DiscoverYourNextAdventure() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const tickerItems = ["MAURITIUS", "MALDIVES", "EUROPE", "SAFARI", "FLIGHTS", "MAURITIUS", "MALDIVES", "EUROPE", "SAFARI", "FLIGHTS"];
  return <section data-section-id="1285" id="discover-your-next-adventure" className="dark bg-background text-foreground min-h-screen w-full overflow-hidden flex items-center justify-center py-0 px-6 md:px-12 lg:px-16">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_hero_landscape.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_hero_landscape.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/travel_hero_landscape.webp-wvc-sizes" alt="Stunning tropical beach landscape with turquoise water" className="h-full w-full object-cover opacity-40" loading="eager" decoding="async" />
        <div className="absolute inset-0 bg-background/70" />
        <div className="absolute inset-0 opacity-[0.08] mix-blend-overlay pointer-events-none" style={{
        backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
      }} />
      </div>

      {}
      <div className="absolute top-20 md:top-24 left-0 right-0 z-20 overflow-hidden border-y border-[hsl(206_30%_24%)]">
        <div className="flex whitespace-nowrap py-3 animate-[ticker_40s_linear_infinite] hover:[animation-play-state:paused]">
          {tickerItems.map((item, i) => <div key={i} data-index={i} className="flex items-center shrink-0">
              <span className="font-mono text-xs tracking-[0.18em] uppercase text-foreground px-6">
                {item}
              </span>
              <span className="size-1.5 bg-secondary shrink-0" aria-hidden="true" />
            </div>)}
        </div>
      </div>

      {}
      <div aria-hidden="true" className="absolute bottom-0 -right-8 md:right-0 z-10 pointer-events-none select-none leading-none" style={{
      fontFamily: "var(--font-sans)",
      fontSize: "clamp(18rem, 32vw, 36rem)",
      color: "hsl(206 67% 55% / 0.06)",
      letterSpacing: "-0.02em"
    }}>
        01
      </div>

      {}
      <div className="relative z-30 w-full max-w-[1600px] px-6 md:px-12 lg:px-16 pt-32 pb-32 md:pt-40 md:pb-40 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 items-center">
        {}
        <div className="flex items-center gap-3 mb-8 md:mb-0">
          <span className="font-mono text-xs md:text-sm font-medium tracking-[0.18em] uppercase text-foreground">&nbsp;01 / EXPLORE</span>
          <span className="h-px w-10 bg-[hsl(206_30%_24%)]" aria-hidden="true" />
        </div>

        {}
        <div ref={headlineRef} className={`text-center transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <h1 className="font-default font-normal uppercase text-foreground text-4xl md:text-6xl lg:text-8xl" style={{
          letterSpacing: "-0.02em",
          lineHeight: "0.82"
        }}>
            <span className="block">Discover Your</span>
            <span className="block">
              <span className="relative inline-block">
                <span className="font-serif italic !text-[rgba(55,115,160,1)]" style={{
                fontSize: "0.85em",
                letterSpacing: "0.01em"
              }}>
                  Next
                </span>
                <span aria-hidden="true" className="absolute left-0 right-0 -bottom-2 md:-bottom-3 origin-left flex items-center" style={{
                transform: "rotate(-6deg)"
              }}>
                  <span className={`h-px bg-primary transition-transform duration-700 ease-out origin-left ${headlineVisible ? "scale-x-100" : "scale-x-0"}`} style={{
                  width: "100%"
                }} />
                  <span className={`size-1.5 bg-primary shrink-0 transition-all duration-300 ${headlineVisible ? "opacity-100 scale-100" : "opacity-0 scale-0"}`} style={{
                  transitionDelay: headlineVisible ? "700ms" : "0ms"
                }} aria-hidden="true" />
                </span>
              </span>{" "}
              Adventure
            </span>
          </h1>

          <div className={`mt-10 md:mt-14 transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
          transitionDelay: headlineVisible ? "160ms" : "0ms"
        }}>
            <p className="font-mono text-xs md:text-sm font-medium tracking-[0.2em] uppercase text-foreground/80">
              Curated Travel Packages — Worldwide Destinations
            </p>
          </div>
        </div>

        {}
        <div ref={ctaRef} className={`flex justify-center md:justify-end transition-all duration-[520ms] ease-[cubic-bezier(0.2,0.8,0.2,1)] ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
        transitionDelay: ctaVisible ? "240ms" : "0ms"
      }}>
          <div className="relative group inline-block">
            <Button asChild className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-medium [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs has-[>svg]:px-3 rounded-lg text-secondary-foreground border-[1.5px] border-secondary px-9 py-6 h-auto font-default uppercase tracking-[0.04em] text-base transition-all duration-[180ms] ease-out relative z-10 group-hover:translate-x-1 group-hover:-translate-y-1 !bg-[rgba(5,25,56,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-secondary/90 md:text-lg">
              <Link to="/ShopPage">
                Book Your Trip
                <ArrowRight className="ml-1 size-5" strokeWidth={1.5} />
              </Link>
            </Button>
            <span aria-hidden="true" className="absolute inset-0 bg-foreground -z-0 opacity-0 group-hover:opacity-100 transition-all duration-[180ms] ease-out translate-x-0 translate-y-0 group-hover:translate-x-1 group-hover:translate-y-1" />
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 z-20 pointer-events-none overflow-hidden">
        <div className="relative h-6 flex items-center" style={{
        transform: "rotate(-6deg) translateY(0)"
      }}>
          <span className="h-px bg-secondary flex-1" />
          <span className="size-1.5 bg-secondary shrink-0 mr-4" aria-hidden="true" />
        </div>
      </div>

      <style>{`
        @keyframes ticker {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}